"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const roomViewStore_1 = require("@/room/room_view/roomViewStore");
const react_i18next_1 = require("react-i18next");
const components_1 = require("@/common/components");
const functions_1 = require("@/common/functions");
const eggs_1 = require("@/common/eggs");
const material_ui_confirm_1 = require("material-ui-confirm");
function default_1({ isPreview }) {
    const isLoggedIn = (0, react_redux_1.useSelector)((state) => { var _a; return (_a = state.whoAmI) === null || _a === void 0 ? void 0 : _a.is_logged_in; });
    const userId = (0, react_redux_1.useSelector)((state) => { var _a; return (_a = state.whoAmI) === null || _a === void 0 ? void 0 : _a.id; });
    const channelId = (0, react_redux_1.useSelector)((state) => state.roomData.leader);
    const leaderNick = (0, react_redux_1.useSelector)((state) => state.roomData.leader_nick);
    const dispatch = (0, react_redux_1.useDispatch)();
    const onSubsChanged = (subscribed) => {
        dispatch((0, roomViewStore_1.setIsSubscribe)(subscribed));
    };
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const [pending, setPending] = (0, react_1.useState)(false);
    const onSubscribeClick = () => {
        if (!isPreview) {
            if (userId === channelId) {
                (0, eggs_1.preventMyself)({ confirm, message: t('자신을 구독하지 말아요') });
            }
            else {
                !pending &&
                    (0, functions_1.changeSubscribeState)({
                        isLoggedIn,
                        setPending,
                        channelId,
                        onSubsChanged,
                    });
            }
        }
    };
    const isSubscribe = (0, react_redux_1.useSelector)((state) => state.roomData.is_subscribe);
    return ((0, jsx_runtime_1.jsx)(components_1.SubscribeMenuButton, { btnCSS: { width: '100%', height: '40px', borderRadius: '8px', fontSize: '15px' }, isSubscribe: isSubscribe, pending: pending, onSubscribeClick: onSubscribeClick, leaderNick: leaderNick }));
}
exports.default = default_1;
